/** True when the asset class has an on-chain contract linked (batch minting requires it). */
export function hasAssetClassDeployedContract(assetClass) {
  const a = String(assetClass?.contractAddress ?? assetClass?.ContractAddress ?? '').trim();
  return a.length > 0;
}

/**
 * Offline contract deployment in the tokenizer Asset Class Manager: only classes created by this
 * authorized tokenizer (not platform / admin catalog classes).
 */
export function canAuthorizedTokenizerDeployAssetClassContract(assetClass, authorizedTokenizerId) {
  if (!authorizedTokenizerId || !assetClass) return false;
  if (assetClass.isPlatformStandard) return false;
  const owner =
    assetClass.createdByAuthorizedTokenizerId ??
    assetClass.CreatedByAuthorizedTokenizerId ??
    null;
  if (owner == null || owner === '') return false;
  return String(owner).toLowerCase() === String(authorizedTokenizerId).toLowerCase();
}

/** Core contract strip + deploy modal: full access for admin; tokenizer rules otherwise. */
export function shouldShowAssetClassContractDeploymentUi(assetClass, { isAdmin, authorizedTokenizerId }) {
  if (isAdmin) return true;
  return canAuthorizedTokenizerDeployAssetClassContract(assetClass, authorizedTokenizerId);
}

/**
 * Core contract card on asset class tiles: show read-only address (copy / explorer) whenever a contract exists so
 * tokenizers see the same on-chain info as admins for platform-standard classes. Deploy controls stay gated by
 * {@link shouldShowAssetClassContractDeploymentUi}.
 */
export function shouldShowAssetClassContractCard(assetClass, { isAdmin, authorizedTokenizerId }) {
  const addr = String(assetClass?.contractAddress || '').trim();
  if (addr) return true;
  if (shouldShowAssetClassContractDeploymentUi(assetClass, { isAdmin, authorizedTokenizerId })) return true;
  if (assetClass?.isPlatformStandard && !isAdmin && authorizedTokenizerId) return true;
  return false;
}
